import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function card(theme: Theme): ComponentStyle {
  return {
    componentName: 'card',
    baseStyle: {},
    variants: {
      chartKpiCard: {
        background: theme.colors.foreground,
        padding: `${theme.space['2xs']} ${theme.space['xs']}`
      },
      nested: {
        background: theme.colors.foreground,
        padding: `${theme.space['xs']} ${theme.space['s']}`
      }
    }
  };
}
